<template>
  <base-button
    :type="isGeolocationToolActive ? 'alternative' : 'text'"
    :toggled="isGeolocationToolActive"
    size="sm"
    icon="mdi-crosshairs-gps"
    :tooltip="toolTooltip"
    @click="toggleGeolocation"
  />
</template>

<script>
import { get } from 'vuex-pathify';

export default {
  name: 'TheNavbarToolsPanelGeolocation',
  computed: {
    isGeolocationToolActive: get('tools/toolStatus@isGeolocationToolActive'),
    toolTooltip() {
      return this.isGeolocationToolActive
        ? this.$i18n.t('tooltips.hideLocation')
        : this.$i18n.t('tooltips.showLocation');
    },
  },
  methods: {
    toggleGeolocation() {
      this.$root.$emit('geolocation-action', this.isGeolocationToolActive ? false : true);
    },
  },
  beforeDestroy() {
    if (this.isGeolocationToolActive) this.$root.$emit('geolocation-action', false);
  },
};
</script>

<style lang="scss" scoped>
.background {
  @include activeToolButtonStyle();
}
</style>
